// De dónde vienen los huéspedes y cuántos repiten.

import type { HistoricoReservasResult } from '@/lib/types';
import { Tarjeta, BarrasTramos, fmtNum, fmtPct, nombrePais } from './comun';

const MAX_PAISES = 12;

export default function SeccionHuespedes({ data }: { data: HistoricoReservasResult }) {
  const { kpis } = data;
  const conPais = kpis.reservas - data.sinPais;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
      <Tarjeta
        titulo="País de origen"
        info="País que el huésped declara en el canal (container guests de sereno_shared). Solo lo tiene alrededor de la mitad de los huéspedes, así que los porcentajes son sobre las reservas con país conocido y hay que leerlos como una muestra."
        extra={
          <span className="text-xs text-sereno-dark/50 whitespace-nowrap">
            {fmtNum(conPais)} con país · {fmtNum(data.sinPais)} sin
          </span>
        }
      >
        <BarrasTramos
          filas={data.paises.slice(0, MAX_PAISES).map((p) => ({
            etiqueta: nombrePais(p.codigo),
            valor: p.reservas,
            texto: fmtNum(p.reservas),
            detalle: fmtPct(conPais > 0 ? (p.reservas / conPais) * 100 : 0),
          }))}
          vacio="Ningún huésped con país declarado"
        />
        {data.paises.length > MAX_PAISES && (
          <p className="mt-3 text-xs text-sereno-dark/40">
            Y {fmtNum(data.paises.length - MAX_PAISES)} países más con {fmtNum(data.paises.slice(MAX_PAISES).reduce((s, p) => s + p.reservas, 0))} reservas.
          </p>
        )}
      </Tarjeta>

      <Tarjeta
        titulo="Huéspedes que repiten"
        info="Un cliente es la misma persona aunque tenga varios perfiles de huésped en Hostify: se agrupan por teléfono o email (container guest_customers). Repetidor = cliente con dos o más reservas confirmadas en el histórico filtrado."
      >
        <div className="grid grid-cols-3 gap-3 mb-4 text-sm">
          <Mini label="Clientes distintos" valor={fmtNum(kpis.huespedesUnicos)} />
          <Mini label="Repetidores" valor={fmtNum(kpis.repetidores)} sub={fmtPct(kpis.huespedesUnicos > 0 ? (kpis.repetidores / kpis.huespedesUnicos) * 100 : 0)} />
          <Mini label="Reservas de repetidores" valor={fmtNum(kpis.reservasRepetidores)} sub={fmtPct(kpis.pctReservasRepetidores)} />
        </div>
        <BarrasTramos
          filas={data.repetidores.map((t) => ({
            etiqueta: t.tramo,
            valor: t.huespedes,
            texto: `${fmtNum(t.huespedes)} clientes`,
            detalle: `${fmtNum(t.reservas)} res.`,
          }))}
        />
      </Tarjeta>
    </div>
  );
}

function Mini({ label, valor, sub }: { label: string; valor: string; sub?: string }) {
  return (
    <div className="rounded-lg bg-sereno-blue/20 px-3 py-2">
      <p className="text-[11px] text-sereno-dark/50">{label}</p>
      <p className="font-semibold">
        {valor}
        {sub && <span className="ml-1 text-xs font-normal text-sereno-dark/50">{sub}</span>}
      </p>
    </div>
  );
}
